import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';

/**
 * 定义 PicAndWordsSum 组件
 * 图文摘要组件
 */
class PicAndWordsSum extends React.PureComponent {
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const articleArr = content || [];

        const articlesMap = articleArr.map((eachArticle, index) => {
            let audioCover = null;

            if (eachArticle.audioCoverPic) {
                audioCover = <img src={eachArticle.audioCoverPic} className={styles.audioPic} />;
            }

            return (
                <div className={styles.artArea} key={index}>
                    <div className={styles.leftArtPic}>
                        <a href={eachArticle.url} target="_blank" rel="noopener noreferrer">
                            <img src={eachArticle.src} className={styles.bgPic} />
                            {audioCover}
                        </a>
                    </div>
                    <div className={styles.rightArtCon}>
                        <a href={eachArticle.url} target="_blank" id="column_art" rel="noopener noreferrer">
                            <h3>{eachArticle.title}</h3>
                            <p>{eachArticle.des}</p>
                        </a>
                        <div className={styles.artTime}>
                            <p>{eachArticle.time}</p>
                            <a href={eachArticle.url} target="_blank" rel="noopener noreferrer">
                                [详情]
                            </a>
                        </div>
                    </div>
                </div>
            );
        });

        return <div className={styles.columnArt}>{articlesMap}</div>;
    }
}

/**
 * 定义组件属性类型
 * */
PicAndWordsSum.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
PicAndWordsSum.defaultProps = {};

export { PicAndWordsSum };
export default PicAndWordsSum;
